function importAll(r) {
    // Import all images in src/images
    let images = {};
    r.keys().forEach((key) => {
        // Remove leading "./" so keys look like "icons/logo.png"
        const cleanKey = key.replace("./", "");
        images[cleanKey] = r(key);
    });
    return images;
}
const images = importAll(
    require.context("../images", true, /\.(png|jpe?g|svg)$/)
);

const localizedImages = importAll(
    require.context("../images/markdown", true, /\.(png|jpe?g|svg)$/)
);

export function getImage(key) {
    return images[key];
}

export function getImageURL(key) {
    // Wraps images in URL for use in background images etc
    return `url(${images[key]})`;
}

export function getLocalizedMarkdownImage(markdownName, img, language) {
    const key = `${markdownName}/${language}/${img}`;
    return localizedImages[key];
}
